module.exports = __webpack_public_path__ + "fonts/Canaro-ExtraBold.f7242359.woff2";